export const LOADING = 'bookmark.LOADING';
export const LOADED = 'bookmark.LOADED';
